import React from 'react';
import classNames from 'classnames';
import cls from './InProgressEstimates.module.css';
import { useInProgressEstimates } from './useInProgressEstimates';
import { ProgressbarCircle } from '../../UI/ProgressbarCircle/ProgressbarCircle';
import { ProgressbarLineList } from '../../UI/ProgressbarLineList/ProgressbarLineList';
import { ProgressbarLine } from '../../UI/ProgressbarLine/ProgressbarLine';
import { DashboardEstimate } from '../../../../types/dashboardInformation';
import { HintEmptyEstimate } from '../../UI/HintEmptyEstimate/HintEmptyEstimate';

interface InProgressEstimatesProps {
    classes?: string;
    activeTab: string;
}

export const InProgressEstimates = ({ classes, activeTab }: InProgressEstimatesProps) => {
    const { estimates, inProgressEstimates, is_customer } = useInProgressEstimates();
    return (
        <div className={classNames(cls.InProgressEstimates, [classes])}>
            <ProgressbarCircle
                estimateCount={estimates.in_exploitations_estimates_count}
                //@ts-ignore
                value={numberFormatter.formatMoney(estimates.in_exploitations_estimates_cost, 2, estimates.currency.sign)}
                percent={estimates.in_exploitations_estimates_done_percent}
            />
            {estimates.in_exploitations_estimates_count > 0 ? (
                <div className={cls.ProgressbarLineListContainer}>
                    <ProgressbarLineList>
                        {inProgressEstimates.map((inProgressEstimate: DashboardEstimate) => (
                            <ProgressbarLine
                                key={inProgressEstimate.id}
                                estimateName={inProgressEstimate.name}
                                estimateId={inProgressEstimate.id}
                                value={inProgressEstimate.done_percent}
                                status={inProgressEstimate.status}
                            />
                        ))}
                    </ProgressbarLineList>
                </div>
            ) : (
                <HintEmptyEstimate status={activeTab} isCustomer={is_customer} />
            )}
        </div>
    );
};
